import React from "react";
import Paper from "@material-ui/core/Paper";
import CheckIcon from "@material-ui/icons/Check";
import { SearchOutlined } from "@material-ui/icons";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import PriceTableSelector from "../PriceTableSelector";
import BarraProdutosFiltro from "./BarraProdutosFiltro";
import { TagProdutoPromocional, estiloLinhaProdutoPromocional } from "./ProdutoPromocional";

const PriceTableDropdown = React.memo(function PriceTableDropdown({
  nomeFilial,
  tabelasPreco,
  tabelaPrecoSelecionada,
  onTrocarTabelaPreco,
  ticketTabelaPrecoIdSalvo
}) {
  return (
    <PriceTableSelector
      nomeFilial={nomeFilial}
      tabelas={tabelasPreco}
      selectedId={tabelaPrecoSelecionada}
      onChange={onTrocarTabelaPreco}
      disabled={Boolean(ticketTabelaPrecoIdSalvo)}
    />
  );
});

const formatBRL = (value) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);

function RenderTableProdutosRoma({
  classes,
  estoqueOpen,
  produtos,
  produtosFiltrados,
  totalProdutosEncontrados,
  nomeFilial,
  tabelasPreco,
  tabelaPrecoSelecionada,
  ticketTabelaPrecoIdSalvo,
  onTrocarTabelaPreco,
  checkeds,
  onAvancar,
  onCheckedProduto,
  onRowClick,
  onBuscaEstoqueOutraLoja,
  maxProdutosBusca,
  buscaImagemHabilitada,
  grupos,
  gruposSelecionados,
  onAplicarGrupos,
}) {
  if (process.env.REACT_APP_ROMA !== "on") return null;
  if (!estoqueOpen) return null;

  const produtosSafe = Array.isArray(produtos) ? produtos : [];
  const filtradosSafe = Array.isArray(produtosFiltrados) ? produtosFiltrados : [];
  const checkedsSafe = Array.isArray(checkeds) ? checkeds : [];

  const podeRenderizarTabela =
    produtosSafe.length > 0 &&
    typeof nomeFilial === "string" &&
    nomeFilial.length > 1;

  if (buscaImagemHabilitada) {
    return (
      <div className={classes.estoqueBox}>
        {estoqueOpen && (
          <PriceTableDropdown
            nomeFilial={nomeFilial}
            tabelasPreco={tabelasPreco}
            tabelaPrecoSelecionada={tabelaPrecoSelecionada}
            onTrocarTabelaPreco={onTrocarTabelaPreco}
            ticketTabelaPrecoIdSalvo={ticketTabelaPrecoIdSalvo}
          />
        )}
        {estoqueOpen && (
          <BarraProdutosFiltro
            total={totalProdutosEncontrados}
            totalCarregado={produtosSafe.length}
            max={maxProdutosBusca}
            grupos={grupos}
            gruposSelecionados={gruposSelecionados}
            onAplicarGrupos={onAplicarGrupos}
          />
        )}
        {podeRenderizarTabela && (
          <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
            {!tabelaPrecoSelecionada ? (
              <p>Selecione uma tabela de preço</p>
            ) : (
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                    <TableCell>
                      <b>
                        <button className={classes.btnAvancar} onClick={onAvancar}>
                          <b>Avançar</b>
                        </button>
                      </b>
                    </TableCell>
                    <TableCell className={classes.tablecellProduto}>
                      <b>Produto</b>
                    </TableCell>
                    <TableCell>
                      <b>Estoque</b>
                    </TableCell>
                    <TableCell>
                      <b>Preço venda</b>
                    </TableCell>
                    <TableCell>
                      <b>Outras lojas</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtradosSafe.map((item) => {
                    const isChecked = checkedsSafe.some((i) => i.id === item.id);
                    return (
                      <TableRow
                        key={item.id}
                        style={{ cursor: "pointer", ...estiloLinhaProdutoPromocional(item) }}
                      >
                        <TableCell className={classes.labelcheckbox}>
                          <input
                            type="checkbox"
                            className={classes.input}
                            checked={isChecked}
                            readOnly
                          />
                          <div className={`${classes.box} ${isChecked ? classes.checked : ""}`}>
                            <CheckIcon
                              className={`${classes.checkIcon} ${isChecked ? classes.checkIconVisible : ""}`}
                            />
                          </div>
                        </TableCell>
                        <TableCell
                          onClick={() => onCheckedProduto(item)}
                          sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                        >
                          {item.nome}
                          <TagProdutoPromocional item={item} />
                        </TableCell>
                        <TableCell
                          onClick={() => onCheckedProduto(item)}
                          sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                        >
                          {item.estoque}
                        </TableCell>
                        <TableCell
                          onClick={() => onCheckedProduto(item)}
                          sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                        >
                          {formatBRL(item.precoVenda)}
                        </TableCell>
                        <TableCell
                          onClick={() => onBuscaEstoqueOutraLoja({ item })}
                          style={{ textAlign: "center" }}
                          sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                        >
                          <SearchOutlined />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}
      </div>
    );
  }

  return (
    <div className={classes.estoqueBox}>
      {estoqueOpen && (
        <PriceTableDropdown
          nomeFilial={nomeFilial}
          tabelasPreco={tabelasPreco}
          tabelaPrecoSelecionada={tabelaPrecoSelecionada}
          onTrocarTabelaPreco={onTrocarTabelaPreco}
          ticketTabelaPrecoIdSalvo={ticketTabelaPrecoIdSalvo}
        />
      )}
      {estoqueOpen && (
        <BarraProdutosFiltro
          total={totalProdutosEncontrados}
          totalCarregado={produtosSafe.length}
          max={maxProdutosBusca}
          grupos={grupos}
          gruposSelecionados={gruposSelecionados}
          onAplicarGrupos={onAplicarGrupos}
        />
      )}
      {podeRenderizarTabela && (
        <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                <TableCell>
                  <b>Produto</b>
                </TableCell>
                <TableCell>
                  <b>Estoque</b>
                </TableCell>
                <TableCell>
                  <b>Preço venda</b>
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <b>Outras lojas</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtradosSafe.map((item) => (
                <TableRow key={item.id} style={estiloLinhaProdutoPromocional(item)}>
                  <TableCell
                    onClick={() => onRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    {item.nome}
                    <TagProdutoPromocional item={item} />
                  </TableCell>
                  <TableCell
                    onClick={() => onRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    {item.estoque}
                  </TableCell>
                  <TableCell
                    onClick={() => onRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    {formatBRL(item.precoVenda)}
                  </TableCell>
                  <TableCell
                    onClick={() => onBuscaEstoqueOutraLoja({ item })}
                    style={{ textAlign: "center" }}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    <SearchOutlined />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}

export default React.memo(RenderTableProdutosRoma);
